import type { ReactNode } from "react";
import "./StateMessage.css";

interface StateMessageProps {
  tone?: "loading" | "error" | "empty";
  title: string;
  detail?: string;
  action?: ReactNode;
}

/**
 * Shared loading / error / empty presentation. Every data-driven view in
 * this app renders one of these instead of a blank screen — a stranger at
 * a trade-show booth with a bad cellular signal WILL hit these states.
 */
export function StateMessage({ tone = "empty", title, detail, action }: StateMessageProps) {
  return (
    <div className={`state-message state-message--${tone}`} role={tone === "error" ? "alert" : "status"}>
      <p className="state-message__title">{title}</p>
      {detail && <p className="state-message__detail">{detail}</p>}
      {action && <div className="state-message__action">{action}</div>}
    </div>
  );
}
